import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        template: 'loading',
        version: null,
        showToggler: null,
        changeToggler: null,
        setCurrentTab: null,
        tabDocument: false,
        //TODO2023URL_MANAGER: '',
        URL_MANAGER: 'https://sisep.minedu.gob.bo',
        token: '',
        acl: {
            roles: [],
            permissions: [],
        },
        windowSize: {
            w: 0,
            h: 0,
            isMobile: false
        },
        user: {
            username: '',
            email: ''
        },
        name_user: '',
        persona: {},
        roles: {},
        loadingTabs: true,
        changePasswordDialog: false,
        checkFourMonthPassword: false,
        isInMaintenance: false,
        userInfo: {
            password_vencida: false,
            foto: null,
            telefono_movil: null,
            correo_personal: null,
        },
        sleep: ms => {
            return new Promise(resolve => setTimeout(resolve, ms))
        },
        formatFecha: (f) => {
            let fulldate = f.split("-")[2] + "-";
            switch (f.split("-")[1]) {
                case "01":{ fulldate = fulldate + "Enero"; break;}
                case "02":{ fulldate = fulldate + "Febrero"; break;}
                case "03":{ fulldate = fulldate + "Marzo"; break;}
                case "04":{ fulldate = fulldate + "Abril"; break;}
                case "05":{ fulldate = fulldate + "Mayo"; break;}
                case "06":{ fulldate = fulldate + "Junio"; break;}
                case "07":{ fulldate = fulldate + "Julio"; break;}
                case "08":{ fulldate = fulldate + "Agosto"; break;}
                case "09":{ fulldate = fulldate + "Septiembre"; break;}
                case "10":{ fulldate = fulldate + "Octubre"; break;}
                case "11":{ fulldate = fulldate + "Noviembre"; break;}
                case "12":{ fulldate = fulldate + "Diciembre"; break;}
                default:{break;}
            }
            fulldate = fulldate + "-" + f.split("-")[0];
            return fulldate;
        }
    },
    mutations: {
        setVersion (state, newversion) {
            state.version = newversion
        }
    },
    actions: {
        async verificarToken(store) {
            try {
                if (localStorage.getItem('auth') === null) throw new Error('no auth')
                store.state.token = await localStorage.getItem('auth')
                //await store.state.sleep(5000)
                let response = await axios({
                    method: 'post',
                    headers: { Authorization: "Bearer " + store.state.token },
                    url: store.state.URL_MANAGER + '/db-service/db-service-oauth-acl/api/v1/list-roles'
                    //url: store.state.URL_MANAGER + '/app/app-abms/api/v1/servicio_app_abms/usuario/configuracion'
                })
                //let config = await axios({
                //    method: 'post',
                //    data: { token: store.state.token },
                    // FIX: 
                //    url: store.state.URL_MANAGER + '/app/app-login/api/v1/oauth/get-config'
                    //url: store.state.URL_MANAGER + '/api/v1/oauth/get-config'
                //})
                let persona = await axios({
                    method: 'post',
                    headers: { Authorization: "Bearer " + store.state.token },
                    // FIX: 
                    url: store.state.URL_MANAGER + '/db-service/db-service-oauth-acl/api/v1/user-info'
                    //url: store.state.URL_MANAGER + '/api/v1/oauth/get-config'
                })
                //store.state.user.username = config.data.user.user_name
                //store.state.user.email = config.data.user.email
                store.state.user.username = persona.data.name;
                store.state.user.email = persona.data.email;
                store.state.persona = persona.data;
                store.state.roles = response.data;

                if(store.state.persona.nombre1.length > 0 || store.state.persona.nombre2.length > 0) {
                    store.state.name_user = store.state.persona.nombre1 + ' ';
                    store.state.name_user += (store.state.persona.paterno == '') ? store.state.persona.materno : store.state.persona.paterno;
                    store.state.name_user = store.state.name_user.toLowerCase();
                }
                else {
                    store.state.name_user = persona.data.email;
                }

                let permissions = []
                for (var rol in store.state.roles) {
                    //store.state.acl.permissions.push(store.state.roles[rol].slug)
                    permissions.push(store.state.roles[rol].slug)
                }
                store.state.acl.permissions = permissions
                store.state.loadingTabs = false

                let check = await axios.post(
                    'https://sisep.minedu.gob.bo/db-service/db-service-oauth-acl/api/v1/credentialStatus',
                    //TODO2023'/db-service/db-service-oauth-acl/api/v1/credentialStatus',
                    {user:store.state.user.email},
                    {headers:{'Content-Type':'application/json','Accept':'application/json'}}
                );
                if(check.data.status != "authorized"){
                    store.state.changePasswordDialog = true
                }
                else{
                    store.state.checkFourMonthPassword = false
                    let responseUserInfo = await axios.get(
                        'https://sisep.minedu.gob.bo/db-service/db-service-oauth-acl/api/v2/verify-password-expired',
                        {
                            headers:{
                                'Content-Type':'application/json',
                                'Accept':'application/json',
                                'Authorization': "Bearer " + store.state.token
                            }
                        }
                    )
                    if(responseUserInfo.data.status == "OK"){
                        if(responseUserInfo.data.message == "Usuario temporal"){
                            store.state.checkFourMonthPassword = false
                        }
                        else if(responseUserInfo.data.message == "Usuario recurrente"){
                            if (responseUserInfo.data.hasOwnProperty('password_vencida')) {
                                if(responseUserInfo.data.password_vencida){
                                    store.state.checkFourMonthPassword = true
                                    store.state.userInfo.password_vencida = true
                                }
                                else{
                                    store.state.checkFourMonthPassword = false
                                    store.state.userInfo.password_vencida = false
                                }
                            }
                            else{store.state.userInfo.password_vencida = false}
                            if (responseUserInfo.data.hasOwnProperty('foto')) {
                                store.state.userInfo.foto = responseUserInfo.data.foto;
                            }
                            else{store.state.userInfo.foto = null}
                            if (responseUserInfo.data.hasOwnProperty('telefono_movil')) {
                                store.state.userInfo.telefono_movil = responseUserInfo.data.telefono_movil;
                            }
                            else{store.state.userInfo.telefono_movil = null}
                            if (responseUserInfo.data.hasOwnProperty('correo_personal')) {
                                store.state.userInfo.correo_personal = responseUserInfo.data.correo_personal;
                            }
                            else{store.state.userInfo.correo_personal = null}
                        }
                    }
                }
            } catch (error) {
                //console.log('ERROR', error)
                localStorage.clear()
                window.location.replace("/portada")
            }
            /*response = await
            store.state.token = 'lsadfjalsdfk'
            console.log('my', store.state)*/
        }
    },
})
